import Stage from '../stage/stage.vue';
import Payment from '../payment/payment.vue';
import RaceAdmin from '../race-admin/race-admin.vue';
import RaceOfficer from '../race-officer/race-officer.vue';
import RaceRegistration from '../race-registration/layout/layout.vue';
import EmailSender from '../email-sender/email-sender.vue';
import RaceCoupon from '../race-coupon/race-coupon.vue';
import RaceAvailability from '../race-availability/race-availability.vue';

import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';

export default {
    props: {
        currentRaceId: [Number, String]
    },
    name: 'RaceLayout',
    components: {
        [Popover.name]: Popover,
        'stage': Stage,
        'payment': Payment,
        'race-admin': RaceAdmin,
        'race-officer': RaceOfficer,
        'race-registration': RaceRegistration,
        'email-sender': EmailSender,
        'race-coupon': RaceCoupon,
        'race-availability': RaceAvailability
    },
    data() {
        return {
            is_coupons_view_mode: false,
            is_email_sender_view_mode: false,
            is_race_officer_view_mode: false,
            is_payment_view_mode: false,
            is_race_admin_view_mode: false,
            is_race_registrations_view_mode: false,
            is_availability_view_mode: false,
            is_same_day_races_view_mode: false,

            red_races: [0, 3, 4, 7],
            orange_races: [1],

            is_finished_registration: false,
            is_payment_required: false,
            is_available_race_registrations: false,
            is_use_ti_for_entry: false,

            isProcessing: false,
            isChangingStage: false,
            isProcessingTimeout: null,
            all_stages: [],
            default_stage: {
                label: 'Loading...',
                levels: [
                    {
                        fields: [

                        ]
                    }
                ]
            },
            selected_stage: null,
            selected_stage_index: 0,

            typeByAge_fieldCode: 'TypeByAge',
            typeByAge_init_value: null,
            typeByAge_new_value: null,

            useTiEntry_fieldCode: 'IsUseTiForEntry',
            useTiEntry_init_value: null,
            useTiEntry_new_value: null,
            same_day_races: null,
            main_race_id: 0,
            is_payment_already_viewed: false,
            sanctioning_fee: null,

            name_fieldCode: 'Name'
        }
    },
    watch: {
        selected_stage: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.set_init_settings();
            }
        },
        id: {
            immediate: true,
            handler(val, oldVal) {
                if (val == 0 && this.sdr_id != 0 && oldVal && this.sdr_id != oldVal) {
                    this.$router.push(`/dashboard/my-race/${this.sdr_id}`);
                }
                else {
                    setTimeout(() => { this.init() }, 0)
                }
            }
        }
    },
    computed: {
        tabOfficers() {
            if (this.$route && this.$route && this.$route.query && this.$route.query.tabOfficers > 0) {
                return true;
            }
            return false;
        },
        tabIndex() {
            if (this.$route && this.$route && this.$route.query && this.$route.query.tabIndex) {
                return this.$route.query.tabIndex;
            }
            return 0;
        },
        id() {
            if (this.currentRaceId) {
                return this.currentRaceId;
            }

            return this.$route.params.id;
        },
        sdr_id() {
            if (this.$route.query && this.$route.query.sdrId) {
                return this.$route.query.sdrId;
            }
            return 0;
        },
        is_view_only() {
            if (this.$route.query && this.$route.query.isViewOnly) {
                return true;
            }
            return false;
        },
        skip() {
            if (this.$route.query && this.$route.query.skip) {
                return this.$route.query.skip;
            }
            return false;
        },
        copy_race_id() {
            if (this.$route.query && this.$route.query.copyRaceId) {
                return this.$route.query.copyRaceId;
            }
            return 0;
        },

        header_html() {
            if (!this.is_finished_registration || !this.field_name_value) {
                return 'In case of any questions, you can find help <a style="font-size: 23px;" href="https://triathlonireland.com/Resources/Documents/">here</a>.'
            } else {
                return `Race <span class="green" style="text-transform:uppercase;">"${this.field_name_value}"</span>. In case of any questions, you can find help <a style="font-size: 23px;" href="https://triathlonireland.com/Resources/Documents/">here</a>.`
            }
        },
        field_name_value() {
            if (this.all_stages.length > 1) {
                var field = this.get_field_or_null(this.all_stages[0], this.name_fieldCode);
                if (field && field.currentValue) {
                    return field.currentValue
                }
            }

            return null;
        },
        field_typeByAge_current_stage() {
            return this.get_field_or_null(this.selected_stage, this.typeByAge_fieldCode);
        },
        stages_with_typeByAge_field() {
            var self = this;
            var allStages = [];
            self.all_stages.forEach(stage => { if (self.get_field_or_null(stage, self.typeByAge_fieldCode) != null) { allStages.push(stage); }; });
            return allStages.filter(x => { return x != null });
        },
        count_stages_with_typeByAge_field() {
            return this.stages_with_typeByAge_field.length;
        },
        is_changed_typeByAge() {
            return this.field_typeByAge_current_stage && this.typeByAge_init_value != null && this.typeByAge_init_value != this.field_typeByAge_current_stage.currentValue;
        },
        count_stages_with_not_new_typeByAge_field() {
            var self = this;
            var result = this.stages_with_typeByAge_field.filter(stage => {
                return self.is_stage_has_not_new_type_by_age(stage.label);
            });
            return result.length;
        },

        field_useTiEntry_current_stage() {
            return this.get_field_or_null(this.selected_stage, this.useTiEntry_fieldCode);
        },
        stages_with_useTiEntry_field() {
            var self = this;
            var allStages = [];
            self.all_stages.forEach(stage => { if (self.get_field_or_null(stage, self.useTiEntry_fieldCode) != null) { allStages.push(stage); }; });
            return allStages.filter(x => { return x != null });
        },
        count_stages_with_useTiEntry_field() {
            return this.stages_with_useTiEntry_field.length;
        },
        is_changed_useTiEntry() {
            return this.field_useTiEntry_current_stage && this.useTiEntry_init_value != null && this.useTiEntry_init_value != this.field_useTiEntry_current_stage.currentValue;
        },
        count_stages_with_not_new_useTiEntry_field() {
            var self = this;
            var result = this.stages_with_useTiEntry_field.filter(stage => {
                return self.is_stage_has_not_new_use_ti_entry(stage.label);
            });
            return result.length;
        },

        name() {
            if (this.all_stages.length > 0) {
                return this.get_field_or_null(this.all_stages[0], "Name").currentValue;
            }
            return null;
        },
        type() {
            if (this.all_stages.length > 0) {
                return this.get_field_or_null(this.all_stages[0], "TypeByEvent").currentValue;
            }
            return null;
        },
        start() {
            if (this.all_stages.length > 1) {
                return new Date(this.get_field_or_null(this.all_stages[1], "RaceDateTime").currentValue).toLocaleString()
            }
            return null;
        },
        location() {
            if (this.all_stages.length > 1) {
                return this.get_field_or_null(this.all_stages[1], "Location").currentValue + ", " + this.get_field_or_null(this.all_stages[1], "LocationCounty").currentValue;
            }
            return null;
        },
        using_ti_entry() {
            if (this.all_stages.length > 5) {
                return this.get_field_or_null(this.all_stages[5], this.useTiEntry_fieldCode).currentValue ? "Yes" : "No";
            }
            return null;
        },
        age_group() {
            if (this.all_stages.length > 2) {
                var field = this.get_field_or_null(this.all_stages[2], this.typeByAge_fieldCode);

                if (field && field.answerOptions) {
                    var option = field.answerOptions.filter(x => { return x.value == field.currentValue });
                    if (option.length) {
                        return option[0].label;
                    }
                }

            }
            return null;
        },

        is_visible_payment_tab() {
            return this.is_payment_required &&
                !this.is_view_only &&
                !this.isProcessing &&
                !this.is_used_any_logic_flow &&
                !this.currentRaceId
        },
        is_visible_payment_module() {
            return this.is_payment_required &&
                !this.selected_stage &&
                !this.isProcessing &&
                this.is_payment_view_mode;
        },

        is_visible_race_admins_tab() {
            return !this.isProcessing &&
                !this.is_view_only &&
                !this.is_payment_required &&
                this.is_finished_registration &&
                this.all_stages && this.all_stages.length > 1 &&
                !this.is_used_any_logic_flow;
        },
        is_visible_race_admin_module() {
            return !this.selected_stage &&
                !this.isProcessing &&
                this.is_race_admin_view_mode;
        },

        is_visible_race_registrations_tab() {
            return this.is_available_race_registrations &&
                !this.is_view_only &&
                !this.isProcessing &&
                !this.is_used_any_logic_flow;
        },
        is_visible_race_registrations_module() {
            return this.is_race_registrations_view_mode &&
                this.is_finished_registration &&
                !this.selected_stage &&
                !this.isProcessing;
        },

        is_visible_same_day_races_tab() {
            return this.same_day_races &&
                this.same_day_races.length &&
                !this.is_view_only &&
                !this.isProcessing &&
                !this.is_used_any_logic_flow;

        },
        is_visible_same_day_races_module() {
            return this.is_same_day_races_view_mode &&
                !this.selected_stage &&
                !this.isProcessing;
        },

        is_visible_race_officer_tab() {
            return this.currentRaceId &&
                !this.is_view_only &&
                !this.isProcessing &&
                this.all_stages && this.all_stages.length > 1 &&
                !this.is_used_any_logic_flow;

        },
        is_visible_race_officer_module() {
            return this.is_race_officer_view_mode &&
                !this.selected_stage &&
                !this.isProcessing;
        },

        is_visible_email_sender_tab() {
            return this.currentRaceId &&
                !this.is_view_only &&
                !this.isProcessing &&
                this.all_stages && this.all_stages.length > 1 &&
                !this.is_used_any_logic_flow;

        },
        is_visible_email_sender_module() {
            return this.is_email_sender_view_mode &&
                !this.selected_stage &&
                !this.isProcessing;
        },

        is_visible_coupons_tab() {
            return !this.isProcessing &&
                !this.is_view_only &&
                this.currentRaceId &&
                !this.is_payment_required &&
                this.is_finished_registration &&
                this.all_stages && this.all_stages.length > 1 &&
                !this.is_used_any_logic_flow;
        },
        is_visible_coupons_module() {
            return !this.selected_stage &&
                !this.isProcessing &&
                this.is_coupons_view_mode;
        },

        is_visible_availability_tab() {
            return !this.isProcessing &&
                !this.is_view_only &&
                this.currentRaceId &&
                !this.is_payment_required &&
                this.is_finished_registration &&
                this.all_stages && this.all_stages.length > 1 &&
                !this.is_used_any_logic_flow;
        },
        is_visible_availability_module() {
            return !this.selected_stage &&
                !this.isProcessing &&
                this.is_availability_view_mode;
        },


        is_used_any_logic_flow() {
            return this.useTiEntry_new_value != null || this.typeByAge_new_value != null;
        }
    },
    methods: {
        change_race(id) {
            if (this.currentRaceId) {
                this.$emit("update:currentRaceId", id);
            }
            else {
                this.$router.push(`/dashboard/my-race/${id}`);
            }
        },

        is_stage_has_not_new_type_by_age(stage_label) {
            var stage = this.stages_with_typeByAge_field.filter(x => { return x.label == stage_label });
            if (stage && stage.length) {
                var typeByAgeField = this.get_field_or_null(stage[0], this.typeByAge_fieldCode);
                return typeByAgeField != null && typeByAgeField.currentValue != this.typeByAge_new_value;
            }

            return false;
        },
        is_stage_has_not_new_use_ti_entry(stage_label) {
            var stage = this.stages_with_useTiEntry_field.filter(x => { return x.label == stage_label });
            if (stage && stage.length) {
                var useTiEntryField = this.get_field_or_null(stage[0], this.useTiEntry_fieldCode);
                return useTiEntryField != null && useTiEntryField.currentValue != this.useTiEntry_new_value;
            }

            return false;
        },

        is_red_active(stage_label) {
            if (this.count_stages_with_not_new_typeByAge_field && this.typeByAge_new_value != null) {
                return this.is_stage_has_not_new_type_by_age(stage_label) && this.count_stages_with_not_new_typeByAge_field > 0;
            }

            if (this.count_stages_with_not_new_useTiEntry_field && this.useTiEntry_new_value != null) {
                return this.is_stage_has_not_new_use_ti_entry(stage_label) && this.count_stages_with_not_new_useTiEntry_field > 0;
            }
            return false;
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },

        handler_click_change_tab(stage) {
            var self = this;
            self.clearAll();
            self.selected_stage_index = self.all_stages.indexOf(stage);
            self.changeStage();
        },
        handler_click_payment_tab() {
            this.clearAll();
            this.is_payment_view_mode = true;
        },
        handler_click_race_admin_tab() {
            this.clearAll();
            this.is_race_admin_view_mode = true;
        },
        handler_click_race_officer_tab() {
            this.clearAll();
            this.is_race_officer_view_mode = true;
        },
        handler_click_race_registration_tab() {
            this.clearAll();
            this.is_race_registrations_view_mode = true;
        },
        handler_click_same_day_races_tab() {
            this.clearAll();
            this.is_same_day_races_view_mode = true;
        },
        handler_click_email_sender_tab() {
            this.clearAll();
            this.is_email_sender_view_mode = true;
        },

        handler_click_coupons_tab() {
            this.clearAll();
            this.is_coupons_view_mode = true;
        },
        handler_click_availability_tab() {
            this.clearAll();
            this.is_availability_view_mode = true;
        },

        loadData(wasStages) {
            var self = this;
            if (self.isProcessing) {
                return;
            }
            self.isProcessing = true;
            self.beforeLoading();
            if (self.all_stages && self.all_stages.length && self.all_stages[0].label != "Loading...") {
                self.all_stages = [self.default_stage];
                self.selected_stage = self.default_stage;
            }
            request.getRaceDetails(self.id, self.sdr_id, self.copy_race_id, self.currentRaceId > 0, self.is_view_only)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.isSuccess) {
                        self.is_payment_required = response.body.outputData.isPaymentRequired;
                        self.main_race_id = response.body.outputData.mainRaceId;
                        self.same_day_races = response.body.outputData.sameDayRaces;
                        self.sanctioning_fee = response.body.outputData.sanctioningFee;
                        self.is_finished_registration = response.body.outputData.isFinishedRegistration;
                        self.is_available_race_registrations = response.body.outputData.isRaceRegistration;
                        self.is_use_ti_for_entry = response.body.outputData.isUseTiForEntry;
                        
                        self.prepareResponse(response.body.outputData.stages, wasStages);
                    } else {
                        self.$showError(response.body.message);
                        self.all_stages[0].label = "Loading Failed.";
                    }
                    window.scrollTo(126, 126);
                }, () => {
                    self.isProcessing = false;
                    self.all_stages[0].label = "Loading Failed. Please try again later.";
                    self.$showError();
                });
        },
        prepareResponse(stages, wasStages) {
            var self = this;

            EventBus.$emit("dashboard-header-update-html", null)
            if (!stages || !stages.length) {
                self.all_stages = [{ label: 'Loading Failed', levels: [{ fields: [] }] }];
                return;
            }

            self.all_stages = stages;

            if (self.tabOfficers) {
                self.handler_click_race_officer_tab();
            } else {
                if (self.tabIndex > 1 && self.tabIndex <= self.all_stages.length) {
                    self.selected_stage_index = self.tabIndex - 1;
                }

                if (self.is_payment_required && !self.is_payment_already_viewed && !self.is_view_only) {
                    setTimeout(() => { self.handler_click_payment_tab() }, 0);
                    self.is_payment_already_viewed = true;
                }
                else {
                    if (self.all_stages && self.all_stages.length) {
                        self.changeStage()
                    }
                    if (wasStages && wasStages != self.all_stages.length) {
                        setTimeout(() => { self.go_next() }, 0);
                    }
                }
            }
            EventBus.$emit("dashboard-header-update-html", this.header_html)
        },
        init() {
            this.selected_stage = this.default_stage;
            this.all_stages = [this.default_stage];
            this.selected_stage_index = 0;
            this.loadData();
        },
        clearAll(keepStage) {
            if (!keepStage) {
                this.selected_stage = null;
                this.selected_stage_index = 0;
            }

            this.is_coupons_view_mode = false;
            this.is_race_admin_view_mode = false;
            this.is_race_registrations_view_mode = false;
            this.is_payment_view_mode = false;
            this.is_same_day_races_view_mode = false;
            this.is_race_officer_view_mode = false;
            this.is_email_sender_view_mode = false;
            this.is_availability_view_mode = false;
        },
        changeStage() {
            var self = this;
            self.isChangingStage = true;
            if (this.all_stages && this.all_stages.length) {
                this.selected_stage = this.all_stages[this.selected_stage_index];
            }
            self.setFalseIsChangingStage(this.selected_stage_index == 0 ? 1500 : 100);
        },
        setFalseIsChangingStage(time) {
            var self = this;
            self.isProcessingTimeout = setTimeout(() => {
                self.isChangingStage = false;
            }, time);
        },
        setStage(indexChange) {
            this.selected_stage_index += indexChange;
            this.changeStage();
        },
        go_back() {
            this.setStage(-1);
        },
        beforeLoading() {
            this.same_day_races = [];
            this.typeByAge_new_value = null;
            this.typeByAge_init_value = null;
            this.useTiEntry_new_value = null;
            this.useTiEntry_init_value= null;
            this.is_payment_required = false;
            this.is_finished_registration = false;
            this.is_available_race_registrations = false;
            this.is_use_ti_for_entry = false;
            this.clearAll(true);
        },
        cancel() {
            this.loadData();
        },
        go_next() {
            this.setStage(1);
        },
        get_field_or_null(stage, fieldCode) {
            let result = [];

            if (!stage || !stage.levels || !stage.levels.length) {
                return null;
            }

            stage
                .levels
                .forEach(level => {
                    if (level.fields && level.fields.length) {
                        level.fields
                            .forEach(field => {
                                if (!field.isHidden) {
                                    result.push(field);
                                }
                            });
                    }
                });

            var lookingField = result.filter(x => { return x.fieldCodeVisible == fieldCode });

            if (lookingField && lookingField.length) {
                return lookingField[0];
            }

            return null;
        },
        get_all_valid_fields(stage) {
            if (!stage) {
                stage = this.selected_stage;
            }

            let result = [];
            var allSuccess = true;
            stage
                .levels
                .forEach(level => {
                    if (level.fields && level.fields.length) {
                        level.fields.forEach(field => {
                            if (!field.isHidden) {
                                if (allSuccess && field.warnings && field.warnings.length) {
                                    allSuccess = false;
                                }
                                result.push(field);
                            }
                        })
                    }
                });

            if (!allSuccess) {
                return false;
            }
            return result;
        },
        saveData(id, stageEnumValue, data, skipReload) {
            var self = this;
            if (self.isProcessing) {
                setTimeout(() => {
                    self.saveData(id, stageEnumValue, data, skipReload)
                }, 1500)
                return;
            }

            self.isProcessing = true;
            request.postSaveRaceDetails(id, self.sdr_id, stageEnumValue, data)
                .then(response =>
                    self.process_save_result(response, skipReload),
                    error => {
                        self.isProcessing = false;
                        self.$showError();
                        self.loadData(self.all_stages.length);
                    });
        },
        save() {
            var self = this;
            var fieldsCurrentStage = self.get_all_valid_fields();
            if (!fieldsCurrentStage) {
                this.$showError("Please fill required fields and fix mistakes.");
                return;
            }

            if (self.field_typeByAge_current_stage != null && self.field_typeByAge_current_stage.currentValue != self.typeByAge_init_value && self.typeByAge_new_value == null) {
                self.typeByAge_new_value = self.field_typeByAge_current_stage.currentValue;
            }

            if (self.field_useTiEntry_current_stage != null && self.field_useTiEntry_current_stage.currentValue != self.useTiEntry_init_value && self.useTiEntry_new_value == null) {
                self.useTiEntry_new_value = self.field_useTiEntry_current_stage.currentValue;
            }

            if (self.is_changed_typeByAge && self.count_stages_with_typeByAge_field > 1 && self.count_stages_with_not_new_typeByAge_field) {
                self.$showError(`You've changed "Age Group" value. In order to keep module integrity, please change Age Group also on other red tabs. In other case changes will not be applied.`)
            }
            else
                if (self.typeByAge_new_value != null && !self.count_stages_with_not_new_typeByAge_field) {
                    var fieldsModels = self.getValidFieldsAndLastStage(self.stages_with_typeByAge_field);
                    if (!fieldsModels) {
                        return;
                    }
                    self.saveData(self.id, fieldsModels.lastStage, fieldsModels.allData);
                    self.typeByAge_new_value = null;
                }
                else {
                    if (self.is_changed_useTiEntry && self.count_stages_with_useTiEntry_field > 1 && self.count_stages_with_not_new_useTiEntry_field) {
                        self.$showError(`You've changed "TI Race Entry Usage" value. In order to keep module integrity, please change TI Race Entry Usage also on other red tabs. In other case changes will not be applied.`)
                    }
                    else
                        if (self.useTiEntry_new_value != null && !self.count_stages_with_not_new_useTiEntry_field) {
                            var fieldsModels = self.getValidFieldsAndLastStage(self.stages_with_useTiEntry_field);
                            if (!fieldsModels) {
                                return;
                            }
                            self.saveData(self.id, fieldsModels.lastStage, fieldsModels.allData);
                            self.useTiEntry_new_value = null;
                        }
                        else {
                            self.saveData(self.id, self.selected_stage.enumValue, fieldsCurrentStage);
                        }
                }
        },
        getValidFieldsAndLastStage(stages) {
            var allData = []
            var lastStage = 0;

            for (let i = 0; i < stages.length; i++) {
                var stage = stages[i];
                var stageFields = this.get_all_valid_fields(stage);

                if (!stageFields) {
                    this.$showError("Please fill required fields and fix mistakes.");
                    return false;
                } else {
                    allData.push(...stageFields);
                }

                if (lastStage < stage.enumValue) {
                    lastStage = stage.enumValue;
                }
            }

            return { allData: allData, lastStage: lastStage };
        },
        process_save_result(response, skipReload) {
            this.isProcessing = false;
            if (response && response.body && response.body.isSuccess) {
                if (this.id == 0) {
                    var urlWithoutId = window.location.pathname.split('/').filter((x, index) => { return index != window.location.pathname.split('/').length - 1 }).join("/")
                    if (this.copy_race_id) {
                        this.$router.push(urlWithoutId + "/" + response.body.outputData.id + "?copyRaceId=" + this.copy_race_id);
                    }
                    else {
                        this.$router.push(urlWithoutId + "/" + response.body.outputData.id);
                    }
                }
                if (!skipReload) {
                    this.loadData(this.all_stages.length);
                }
            }
            else {
                this.$showError(response.message);
            }
        },
        set_init_settings() {
            if (this.typeByAge_init_value == null) {
                if (this.typeByAge_new_value != null) {
                    this.typeByAge_init_value = this.typeByAge_new_value;
                } else {
                    var field_typeByAge = this.field_typeByAge_current_stage;
                    if (field_typeByAge) {
                        this.typeByAge_init_value = field_typeByAge.currentValue;
                    };
                }
            }

            if (this.useTiEntry_init_value == null) {
                if (this.useTiEntry_new_value != null) {
                    this.useTiEntry_init_value = this.useTiEntry_new_value;
                } else {
                    var field_useTiEntry = this.field_useTiEntry_current_stage;
                    if (field_useTiEntry != null) {
                        this.useTiEntry_init_value = field_useTiEntry.currentValue;
                    };
                }
            }
        }
    },
    mounted() {
        var self = this;
        EventBus.$off('race-layout-reload')
        EventBus.$on('race-layout-reload', () => {
            self.init();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/layout/layout.js